import React from 'react';
import clsx from 'clsx';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';

import Title from '../../components/Title/Title';
import Pergunta from '../../components/Pergunta/Pergunta';

import useStyles from './Style';

const Premiacao = () => {
    const classes = useStyles();
    return (
        <>
            <Title id="anchor-04" className={classes.title}>
                PREMIAÇÃO
            </Title>

            <Pergunta pergunta="Quando serão divulgados os resultados?">
                A lista dos professores premiados será divulgada na página da Olimpíada de Professores, na data estipulada no <a href="/calendario" target="_blank" rel="noopener noreferrer">Calendário</a> Público.
            </Pergunta>

            <Pergunta pergunta="Quantos professores serão premiados?">
                A premiação dos professores será distribuída seguindo as categorias e as quantidades dispostas no quadro abaixo:
                <br /><br />
                
                <Grid 
                    container 
                    align='center' 
                    direction="row" 
                    justify="center"
                    alignItems="center"
                    className={classes.wrapper}
                >
                    <Grid item sm={10} lg={10}>
                        <TableContainer component="div">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.backGray)} width="25%">Premiação</TableCell>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.backGray)} width="25%">Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#B68D4A', color: '#FFFFFF' }}>Medalha de OURO</TableCell>
                                        <TableCell align="center" className={classes.bolder}>25</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#A3A2A0', color: '#FFFFFF' }}>Medalha de PRATA</TableCell>
                                        <TableCell align="center" className={classes.bolder}>50</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#A46628', color: '#FFFFFF' }}>Medalha de BRONZE</TableCell>
                                        <TableCell align="center" className={classes.bolder}>100</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>Menção Honrosa</TableCell>
                                        <TableCell align="center" className={classes.bolder}>500</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Pergunta>

            <Pergunta pergunta="Quais os prêmios para os professores?">
                O professor premiado com <b>Medalha</b> será condecorado com os prêmios, a saber, a depender do tipo de medalha conquistada (<b>ouro, prata ou bronze</b>):
                <br /><br />
                
                <Grid 
                    container 
                    align='center' 
                    direction="row" 
                    justify="center"
                    alignItems="center"
                    className={classes.wrapper}
                >
                    <Grid item sm={10} lg={10}>
                        <TableContainer component="div">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.backGray)} width="40%">Prêmio</TableCell>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#B68D4A', color: '#FFFFFF' }} width="20%">Ouro</TableCell>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#A3A2A0', color: '#FFFFFF' }} width="20%">Prata</TableCell>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#A46628', color: '#FFFFFF' }} width="20%">Bronze</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>Medalha</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>Certificado Digital</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>
                                            Participação no Curso Digital de Formação em Matemática para Professores do Ensino Fundamental I
                                        </TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>Kit pedagógico</TableCell>
                                        <TableCell align="center">Não</TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Não</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>
                                            Participação presencial de parte das aulas do Curso Digital de Formação em Matemática para Professores do Ensino Fundamental I
                                        </TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Não</TableCell>
                                        <TableCell align="center">Não</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>
                                            Participação na Cerimônia Nacional de Premiação dos Medalhistas de Ouro da OBMEP
                                        </TableCell>
                                        <TableCell align="center">Sim</TableCell>
                                        <TableCell align="center">Não</TableCell>
                                        <TableCell align="center">Não</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>

                <br />
                O professor premiado com Menção Honrosa será condecorado com Certificado Digital.
            </Pergunta>
        </>
    )
}

export default Premiacao;
